<template>
  <div>
      <PageTagline :elements="tagline_elem" />

      <!-- CARD DI CONTENIMENTO DELLA TABELLA DEI VOUCHER ACQUISTATI -->
      <b-card class="mr-1 ml-1" title="Stato dei voucher multiuso acquistati.">
        <!-- Spiegazione dell'area -->
        <b-row class="border-bottom">
          <b-col>
            <p>Nella lista sono riportati i voucher multiuso da te acquistati tramite il nostro welfare di prossimità ( <u>se previsti dal tuo piano welfare</u> ).</p>
          </b-col>
        </b-row>
        <!-- Form con il filtro e la select delle pagine visualizzabili, essendo solo selezioni non usiamo b-form -->
        <b-row class="mt-3">
          <b-col cols="12" md="2">
            <b-form-group id="group-n-righe-per-pagina"
              label="Righe per pagina:"
              label-for="n_elementi"
            >
              <b-form-select id="n_righe_per_pagina"
                v-model="datatable.per_page"
                :options="datatable.righe_per_pagina">
                </b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group id="group-filtro-tabella"
              label="Ricerca:"
              label-for="filtro_tabella"
              description="Ricerca all'interno degli elementi della pagina corrente">
              <b-form-input
                id="filtro_tabella"
                v-model="datatable.filter">
                </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- QUI LA TABELLA --->
        <!-- no-provider-sorting e no-provider-filtering evita che per ogni azione
             di sorting o filtraggio venga chiamato il backend, ma venga fatto dalla
             tabella stessa -->
        <b-table hover stacked="md"
                  :items="get_table_items"
                  :no-provider-filtering="true"
                  :no-provider-sorting="true"
                  :fields="datatable.fields"
                  :current-page="datatable.current_page"
                  :per-page="datatable.per_page"
                  :filter="datatable.filter"
                  show-empty
                  class="border-bottom text-center" >

          <!-- Spinner che informa del caricamento dati attivato dalla tabella quando viene
               chiamata la funzione che prende i dati get_table_items --->
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
              <strong class="text-primary">Caricamento...</strong>
            </div>
          </template>

          <!-- Le colonne della data di produzione e scadenza del voucher le aggiungiamo con -->
          <!-- uno slot apposito perchè dobbiamo visualizzarle nel formato italiano -->
          <template v-slot:cell(data_produzione)="data">
            <p>{{ data.value | toitadate }}</p>
          </template>
          <template v-slot:cell(data_scadenza)="data">
            <p>{{ data.value | toitadate }}</p>
          </template>

          <!-- Colonna del credito residuo, la renderizziamo tramite lo slot per poter visualizzare -->
          <!-- il pulsante sul dettaglio di utilizzo del voucher qualora siano state scaricate delle-->
          <!-- cifre in denaro da quella iniziale -->
          <template v-slot:cell(credito_residuo)="data">
            <p v-if="data.item.voucher_credito_log.length > 0">
              {{data.value}}<br>
              <b-button pill class="mt-2" size="sm" variant="primary" @click="show_detail_modal(data.item)">Dettaglio</b-button>
            </p>
            <p v-else>{{data.value}}</p>
          </template>


          <!-- Calcolo della colonna virtuale voucher_status che informa l'utente sullo stato del -->
          <!-- voucher la quale va calcolata a runtime con le info di ciascun voucher -->
          <template v-slot:cell(voucher_status)="data">
            <p v-if="data.value.is_valid" class="font-weight-bold" style="color:green"><b-icon icon="check-circle-fill" class="mr-2"></b-icon>{{data.value.dettaglio}}</p>
            <p v-else style="color:red" class="font-weight-bold"><b-icon icon="x-circle-fill" class="mr-2"></b-icon>{{data.value.dettaglio}}</p>
          </template>

          <!-- Slot che visualizza un messaggio quando la tabella non ha elementi, deve essere aggiunta
               la proprietà "show-empty" alla tabella -->
          <template v-slot:empty>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun voucher presente</p>
          </template>

          <!-- Slot che visualizza un messaggio quando il filtro non restituisce risultati, deve essere aggiunta
               la proprietà "show-empty" alla tabella -->
          <template v-slot:emptyfiltered>
            <p class="text-center"><font-awesome-icon icon="exclamation-circle" size="lg"/>  Nessun elemento trovato</p>
          </template>
        </b-table>

        <!-- PAGINATORE TABELLA -->
        <div class="mt-3">
          <p class="text-center">Sono presenti {{datatable.total_rows}} elementi.</p>
          <b-pagination v-model="datatable.current_page" :total-rows="datatable.total_rows" :per-page="datatable.per_page" align="center"></b-pagination>
        </div>
      </b-card>

      <!-- LA MODALE PER VEDERE IL DETTAGLIO DEI MOVIMENTI DI UN VOUCHER -->
      <!-- Quando la modale viene chiusa resettiamo l'oggetto che la popola all'apertura -->
      <!-- quando viene chiamata la funzione show_detail_modal -->
      <b-modal ref="detail-modal"
               centered
               scrollable
               title="Dettaglio Movimenti"
               @hidden="detail_modal.credito_log=null; detail_modal.credito_residuo=null">
        <b-table-simple class="text-center">
          <b-thead head-variant="primary">
            <b-tr>
              <b-th>Operazione Effettuata Da</b-th>
              <b-th>Credito Scalato €</b-th>
              <b-th>Data Movimento</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="( item, index ) in detail_modal.credito_log" :key="index">
              <b-td>{{ item.nome_fornitore }}</b-td>
              <b-td>{{ item.credito_scalato }}</b-td>
              <b-td>{{ item.data_movimento | toitadatetime }}</b-td>
            </b-tr>
          </b-tbody>
          <b-tfoot>
            <b-tr>
              <b-th>Importo Residuo € :</b-th>
              <b-th>{{detail_modal.credito_residuo}}</b-th>
              <b-th></b-th>
            </b-tr>
          </b-tfoot>
        </b-table-simple>
        <!-- Modifichiamo il footer in modo da avere solo il bottone per chiudere la modale -->
        <template v-slot:modal-footer="{ cancel }">
          <b-button size="sm" variant="primary" @click="cancel()">
            Chiudi
          </b-button>
        </template>
      </b-modal>
  </div>
</template>


<script>
import PageTagline from '@/components/PageTagline'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'StatoVoucher',
  data () {
    return {
      tagline_elem : [ { text : "Convenzioni special/On Demand", link : 'home-fornitori' },
                       { text : "Stato Voucher Multiuso", link : 'stato-voucher' } ],

      // Oggetto con le info per la tabella
      datatable : {
        // Definizione delle colonne per la tabella.
        // Sono gli elmenti che visualizzo a fronte di quelli che
        // la chiamata al backend mi restituisce.
        fields: [
          {
            key: 'id_acquisto',
            label: 'Id Acquisto Welfare',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'codice',
            label : 'Codice Buono',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          /*
          Siccome i buoni avranno tutti lo stesso oggetto è più
          utile visualizzare il nome del consorzio che lo ha emesso
          {
            key: 'oggetto',
            label: 'Oggetto',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },*/
          {
            key: 'nome_fornitore',
            label: 'Emesso Da',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'data_produzione',
            label: 'Data Emissione',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'data_scadenza',
            label: 'Data Scadenza',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'credito_iniziale',
            label: 'Importo Iniziale €',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          {
            key: 'credito_residuo',
            label: 'Importo Residuo €',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          },
          // Il contenuto di questa colonna non è semplicemente
          // mostrato ma renderizzato a seconda deello stato del voucher
          // vedi lo slot relativo.
          {
            key: 'voucher_status',
            label: 'Status',
            sortable: true,
            thStyle: { backgroundColor: '#b3b3b3' }
          }
        ],

        // Elementi per pagina selezionabili
        righe_per_pagina : [
          { value: 5, text: "5" },
          { value: 10, text: "10" },
          { value: 25, text: "25" },
          { value: 50, text: "50" },
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 500, text: "500" }
        ],

        // Pagina corrente
        current_page : 1,

        // Elementi visualizzabili per pagina, viene modificato
        // dal valore di "righe_per_pagina"
        per_page : 10,

        // Righe totali
        total_rows : 0,

        // Filtro di ricerca.
        filter : null
      },

      // Dati per la modale di dettaglio dei movimenti.
      detail_modal : {
        credito_log : null,
        credito_residuo: null
      }

    }
  },
  methods: {
    /**
     * Interroga il backend e torna gli elementi per popolare la tabella.
     *
     * - ctx: è la variabile di contesto che ci serve per interrogare in maniera corretta il backend
     *        questa contiene le chiavi:
     *                   apiUrl: ""      : url da chiamare, nel nostro caso stringa vuota. Perchè chiamiamo l'url nell funzione e non usiamo la prop
     *                   currentPage: 1  : pagina da chiamare
     *                   filter: null    : variabile di filtro, null oppure pari alla stringa che vogliamo filtare ( VIENE FATTO LATO CLIENT - usiamo no-provider-filter )
     *                   perPage: 50     : numero di risultati per pagina
     *                   sortBy: ""      : stringa vuota a nome della colonna secondo il quale ordinare i dati ( VIENE FATTO LATO CLIENT - usiamo no-provider-sorting )
     *                   sortDesc: false : ordine di sorting, sempre presente, può essere true o false
     *
     * - callback: funzione di callback da chiamare quando i dati sono pronti.
     */
    get_table_items : function (ctx, callback) {

      // Il contesto include alcune chiavi che ci servono per fare la chiamata.
      let api_url = apiUrl.fornitoriapi.get_user_voucher_list + '?page=' + ctx.currentPage + '&page_size=' + ctx.perPage

      axios.get( api_url )
      .then( (response) => {

        // Settiamo il numero totale di righe
        this.datatable.total_rows = response.data.count;

        // Settiamo gli item della tabella e chiamiamo la sua callback
        let items = response.data.results;

        callback ( items );
      })
      .catch( (error) => {
        console.error( error );
        callback ( [] );
      });
    },
    show_detail_modal : function ( item ) {
      this.detail_modal.credito_log = item.voucher_credito_log;
      this.detail_modal.credito_residuo = item.credito_residuo;
      this.$refs['detail-modal'].show();
    }
  },
  components : {
    PageTagline
  }
}
</script>


<style scoped></style>